import { styled } from '@acko-tech/building-blocks.ui.common';
import MuiDrawer from '@mui/material/Drawer';

export const Drawer = styled(MuiDrawer)`
    & .MuiPaper-root {
        margin: 0 auto;
        padding: 24px 16px 16px;
        border-radius: 16px 16px 0 0;
        max-height: 90%;
        max-width: 328px;

        @media (max-width: 700px) {
            max-width: 100%;
        }
    }
`;

export const Heading = styled.div`
    text-align: left;
    margin: 0 0 24px;
    padding-right: 30px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const IconWrapper = styled.div`
    position: absolute;
    right: 20px;
`;
